import { ManpowerSituationType } from '@sportlogiq/shared';

export interface BoxscoreGameScoreBoard {
    team: string;
    logosrc: string;
    teamId: string;
    periodScore: number[];
    shootoutScore: number;
    totalScore: number;
}

export interface BoxscoreScorer {
    period: number;
    playerName: string;
    flags?: string[];
    playerEventId?: string;
    periodTime?: string;
    manpowerSituation?: ManpowerSituationType;
    firstAssistName?: string;
    secondAssistName?: string;
    frameTime?: string | null;
}

export interface BoxscoreGoalie {
    id: string;
    name: string;
    winOrLose?: 'L' | 'W';
}

export interface BoxscorePlayerScorerList {
    period: number;
    scorers: BoxscoreScorer[];
}

export interface BoxscoreScorerList {
    [teamId: string]: BoxscorePlayerScorerList[];
}

export interface BoxscoreGoalieList {
    [teamId: string]: BoxscoreGoalie[];
}

export interface BoxscoreTeam {
    id: string;
    shorthand: string;
    logo: string;
    displayName: string;
}

export interface BoxscoreGoalClipEvent {
    gameId: string;
    playerEventId: string;
    frameTime: string | null;
}

export enum SpecialSituationGoalLabel {
    EMPTY_NET = 'EN',
    PENALTY_SHOT = 'PS',
}

export enum BoxscoreDataCy {
    CONTAINER = 'boxscore-container',
    SCOREBOARD_TABLE = 'scoreboard-table',
    SCORER_DETAILS = 'scorer-details',
    SHORTHAND_TEAMNAME = 'shorthand-teamname',
    GOAL_CLIP_BUTTON = 'goal-clip-button',
    PLAYBACK_GOALS_BUTTON = 'playback-goals-button',
    PLAYBACK_SPECIAL_TEAMS_BUTTON = 'playback-special-teams-button',
    PLAYBACK_FULL_GAME_BUTTON = 'playback-full-game-button',
    SITUATIONS_SELECTOR_BUTTON = 'situations-selector-button',
    GOALIE_LIST = 'boxscore-goalie-list',
    ASSIST_PLAYERS = 'assist-players',
    NO_VIDEO_AVAILABLE = 'no-video-available',
    SCORERS_PERIOD = 'scorers-period'
}
